import { render, staticRenderFns } from "./PagamentoRecebido.vue?vue&type=template&id=5e870503"
import script from "./PagamentoRecebido.vue?vue&type=script&lang=js"
export * from "./PagamentoRecebido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports